import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/user'

export function useAppNavigation() {
  const route = useRoute()
  const { t } = useI18n()
  const user = useUserStore()
  const isBooking = computed(() => route.name === 'services.view')
  const isAdmin = computed(() => route.matched.some(record => record.meta.isAdmin))
  const isProfile = computed(() => ['/profile', '/login', '/register'].includes(route.path) || route.path.startsWith('/password/'))
  const items = computed(() => [
    { path: '/services', label: t('home'), icon: 'home', active: route.path === '/' || route.path.startsWith('/services') },
    { path: '/reservations', label: t('reservations'), icon: 'calendar', active: route.path === '/reservations' },
    { path: '/profile', label: t('profile'), icon: 'user', active: isProfile.value },
    ...(user.auth?.is_admin ? [{ path: '/administration/reservations', label: t('admin'), icon: 'settings', active: isAdmin.value }] : []),
  ])
  const title = computed(() => isBooking.value ? t('book_appointment') : isProfile.value ? t('profile') : route.path === '/reservations' ? t('reservations') : t('services'))
  return { items, isBooking, isAdmin, title }
}
